import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchCategories } from "../../../RTK/productSlice";
import CategoryDetailsPopup from "./AddProductDetailsPopup";
import { 
  Package,
  X,
  Box,
  LayoutGrid,
  Boxes,
  ChevronLeft
} from "lucide-react";

const productTypes = [
  { id: 'quantity', icon: Boxes, label: 'كمية' },
  { id: 'package', icon: Package, label: 'باقة' },
  { id: 'stock', icon: Box, label: 'مخزون' }
];

const AddProductPopup = ({ showPopup, setShowPopup }) => {
  const dispatch = useDispatch();
  const [detailsPopup, setDetailsPopup] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [categoryDetails, setCategoryDetails] = useState(null);

  const handleFetchCategories = async (type) => {
    setSelectedType(type);
    const result = await dispatch(fetchCategories(type)).unwrap();
    setCategoryDetails(result);
    setDetailsPopup(true);
  };

  if (!showPopup) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/70 backdrop-blur-md z-[20000] flex items-center justify-center p-4">
        {/* Main Popup */}
        <div className="w-full max-w-md" dir="rtl">
          <div className="bg-gradient-to-b bg-gray-900  rounded-2xl border border-gray-800/50 shadow-2xl overflow-hidden">
            {/* Header */}
            <div className="relative flex justify-between items-center p-6 after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:bg-gradient-to-r after:from-transparent after:via-gray-700/50 after:to-transparent">
              <h2 className="text-xl font-bold text-white flex items-center gap-3">
                <LayoutGrid className="w-6 h-6 text-[#FEC111]" />
                <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                  إضافة منتج جديد
                </span>
              </h2>
              <button
                onClick={() => setShowPopup(false)}
                className="text-gray-400 w-10 h-10 rounded-full flex items-center justify-center bg-gray-800/50 hover:bg-[#FEC111] hover:text-black transition-all duration-300 hover:scale-105"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
              <div className="grid gap-3">
                {productTypes.map(({ id, icon: Icon, label }) => (
                  <button
                    key={id}
                    onClick={() => handleFetchCategories(id)}
                    className="group flex items-center gap-4 p-4 bg-slate-800/50 rounded-xl border border-gray-800/50 hover:border-[#FEC111]/50 transition-all duration-300 hover:scale-[1.02]"
                  >
                    <div className="w-12 h-12 rounded-xl bg-gray-800/50 flex items-center justify-center group-hover:bg-[#FEC111] transition-colors duration-300">
                      <Icon className="w-6 h-6 text-gray-400 group-hover:text-black" />
                    </div>
                    <span className="flex-1 text-white text-lg font-medium text-right">
                      {label}
                    </span>
                    <ChevronLeft className="w-5 h-5 text-gray-400 group-hover:text-[#FEC111]" />
                  </button>
                ))}
              </div>


            </div>
          </div>
        </div>
      </div>

      {/* Category Details Popup */}
      {detailsPopup && (
        <CategoryDetailsPopup
          selectedType={selectedType}
          details={categoryDetails}
          setDetailsPopup={setDetailsPopup}
        />
      )}
    </>
  );
};

export default AddProductPopup;